module.exports = __webpack_public_path__ + "img/excavator-blue.cddd1b14.svg";